<template>
  <div class="col-md-12 mx-auto">
    <div id="canvas-wrapper" class="text-center sticky-md" style="top: 92px" />
  </div>
</template>

<script>
import { AtomSpinner } from "epic-spinners";

export default {
  name: "qrMaker",

  components: { AtomSpinner },

  props: {
    loading: Boolean,
  },
};
</script>

<style scoped>
#canvas-wrapper >>> canvas {
  max-width: 100%;
  max-height: 300px;
}
</style>
